import React, { useState, useEffect, useRef } from 'react'
import styles from '../../../styles/HomeLanding/IndiaLandingPage.module.css'
import Image from 'next/image';
import { features, firstSectionFeatures } from '@/constants/common';
import useLazyInView from '@/hooks/useLazyInView';

const PosFeatures = () => {
     const [sectionRef, isInView] = useLazyInView('200px 0px');
     const [reachedTop, setReachedTop] = useState({});
    const cardRefs = useRef([]);



    

    useEffect(() => {
        const handleScroll = () => {
            const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const topOffset = 14 * rootFontSize;  
            const increment = 2 * rootFontSize;  

            cardRefs.current.forEach((cardRef, index) => {
                if (cardRef) {
                    const cardRect = cardRef.getBoundingClientRect();
                    const stickyTopInPx = topOffset + (index * increment);
                    
                    
                    const hasReachedTop = cardRect.top <= stickyTopInPx + 1;  

                    setReachedTop(prev => {
                        if (prev[index] !== hasReachedTop) {
                            return { ...prev, [index]: hasReachedTop };
                        }
                        return prev;
                    });
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        cardRefs.current = cardRefs.current.slice(0, features.length);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            // window.removeEventListener('resize', handleScroll);
        };
    }, [features.length]);
    const router = require('next/router').useRouter ? require('next/router').useRouter() : null;
    const handleVectorClick = () => {
    const route =  '/pos-hardware-partners';
    if (router && route) {
      router.push(route);
    }
  };

    return (
        <div ref={sectionRef} style={{  width:"100%", height:"100%", }}>
        <div style={{ display: 'flex', justifyContent: 'space-between',margin: "5rem 18rem",   }} >
            <div style={{
                width: '55%',
                position: 'sticky',
                top: '15rem',
                alignSelf: 'flex-start',
            }}>
                <div style={{ display: 'flex', }}>
                    <h2 style={{ fontSize: "2.8rem", fontFamily: "GilroyBold" }}>
                    Any Hardware.  <br />
                    One Software. 

                    </h2>

                    {/* when we click on this redirect this route "/pos-hardware-partners" */}
                    <div className={styles.vector} onClick={handleVectorClick} style={{ position: 'relative',}}>
                        <div className={styles.vectorImg}>
                            <Image src="/assets/HomeLanding/Vector.svg" alt="POS Solution" fill />
                        </div>
                    </div>
                </div>
                <div className={styles.feature_continer}>


                     {firstSectionFeatures.map((feature, index) => (
                        <div>
                        <ul> <li style={{ color: '#2A6AB4', fontSize: '1.8rem', fontFamily: 'GilroySemiBold', marginLeft: "-0.6rem" }}>  {feature.title} </li> </ul>
                        <p style={{ fontFamily: 'GilroyRegular', fontSize: '1.5rem' }}> {feature.description}</p>
                    </div>

                     ))
                    }
                    
                </div>
            </div>
            {/* right section */}
            <div style={{
                width: '39rem',
                // minHeight: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                top:"10rem",
            }}>
                {features.map((feature, index) => (
                    <div
                        key={index}
                        ref={el => cardRefs.current[index] = el}
                        style={{
                            position: 'sticky',
                            top: `calc(14rem + ${index * 2}rem)`,
                            backgroundColor: feature.backgroundColor,
                            padding: '3rem 3rem 4.5rem 3rem',
                            overflow: 'hidden',
                            borderRadius: '2rem',
                            marginBottom:"4rem",
                            width: '100%',
                            boxSizing: 'border-box',
                            transition: 'transform 0.3s ease-in-out',
                            transform: reachedTop[index] ? 'scale(0.96) perspective(1000px) translateZ(-20px)' : 'scale(1) perspective(1000px) translateZ(0)',
                            transformOrigin: 'top center',
                        }}
                    >
                        <p style={{ fontSize: '2rem', fontFamily: 'GilroyBold', zIndex:1 }}>{feature.number}</p>
                        <p style={{ color: '#5A5A5A', fontSize: "1.5rem", fontFamily: "GilroyRegular",zIndex:2 }}>{feature.txt}</p>
                        <div style={{ position: 'relative', width: feature.imgWidth, height: feature.imgHeight, zIndex:1, top: feature?.imgTop }}>
                            {isInView && (
                                <Image src={feature.img} fill alt={feature.altText} loading="lazy" />
                            )}
                        </div>
                        <div style={{ zIndex:-2,position: 'absolute', width: feature.width, height: feature.height, top:feature.top, left:feature.left, right:feature.right, bottom:feature.bottom}}>
                            {isInView && (
                                <Image src={feature.gradient} fill alt="" loading="lazy" />
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
        </div>
    )
}

export default PosFeatures;